import * as React from 'react';
import * as styles from './spinner.module.css';
import { clsx } from 'clsx';

interface Props extends React.ComponentPropsWithoutRef<"div"> {
	dotAmount?: number
}

function Spinner({className = '', dotAmount = 6, ...otherProps}: Props) {
	return (
		<div className={clsx(styles.spinner, className)} {...otherProps}>
			{[...Array(dotAmount)].map((el, i) => {
				return <div key={'dot' + i} className={styles.dot}/>;
			})}
		</div>
	);
}

export default Spinner;
